"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Wrench, Truck } from "lucide-react";
import { Link } from "@/components/common/Link";
const services = [{
  id: 1,
  title: "Surface Grading Services",
  description: "Professional grading and site preparation for construction projects",
  benefits: ["Precision grading and leveling", "Site preparation expertise", "Efficient project execution", "Certified personal"],
  icon: "wrench"
}, {
  id: 2,
  title: "Equipment Rentals",
  description: "Reliable mid-size construction machinery rental for all your project needs",
  benefits: ["Well-maintained equipment", "Flexible rental options", "Fast availability", "Competitive pricing"],
  icon: "truck"
}];
export default function ServicesInformation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="servicesinformation" className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="mb-16 text-center">
          <h2 className="font-default text-4xl sm:text-5xl font-bold text-foreground mb-4">
            Our Services
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Professional equipment rental and grading services for construction
            projects
          </p>
        </div>

        {}
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {services.map((service, i) => <div key={service.id} data-index={i}>
              <Card className="h-full bg-card hover:shadow-lg transition-shadow duration-300 border border-border">
                <CardHeader>
                  <div className="flex items-start justify-between mb-2">
                    <CardTitle className="font-default text-2xl font-bold text-foreground">
                      {service.title}
                    </CardTitle>
                    <div className="p-3 bg-primary/10 rounded-none">
                      {service.icon === "wrench" ? <Wrench className="w-6 h-6" style={{
                    color: "var(--primary)"
                  }} /> : <Truck className="w-6 h-6" style={{
                    color: "var(--primary)"
                  }} />}
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="space-y-6">
                  <p className="text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>

                  {}
                  <div className="space-y-3">
                    <h3 className="font-default font-semibold text-foreground text-sm uppercase tracking-wider">
                      Key Benefits
                    </h3>
                    <ul className="space-y-2">
                      {service.benefits.map((benefit, idx) => <li key={idx} className="flex items-start gap-3 text-sm text-muted-foreground">
                          <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
                      backgroundColor: "var(--primary)"
                    }} />
                          {benefit}
                        </li>)}
                    </ul>
                  </div>

                  {}
                  <div className="pt-2">
                    <Link to="/BookNowPage">
                      <Button className="w-full bg-primary text-primary-foreground hover:bg-primary/90">
                        {service.id === 1 ? "Request Grading" : "Book Equipment"}
                      </Button>
                    </Link>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}